export default __webpack_public_path__ + "static/media/queshengye-zuoye.3f576a66.png";